import {
  Button,
  chakra,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Stack,
  useToast,
  Center,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { Card } from "../Card";
import { Layout } from "../Layout";
import { useHistory } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ForgotPassword() {
  const history = useHistory();
  const { forgotPassword } = useAuth();
  const toast = useToast();

  const [email, setEmail] = useState("");

  return (
    <Layout>
      <Heading textAlign="center" my={12}>
        Forgot password
      </Heading>
      <Card maxW="md" mx="auto" mt={4}>
        <chakra.form
          onSubmit={async (e) => {
            e.preventDefault();
            // your login logic here
            try {
              await forgotPassword(email);
              toast({
                description: `An email is sent to ${email} for password reset instructions.`,
                status: "success",
                duration: 9000,
                isClosable: true,
              });
            } catch (error) {
              console.log(error.message);
              toast({
                description: error.message,
                status: "error",
                duration: 9000,
                isClosable: true,
              });
            }
          }}
        >
          <Stack spacing="6">
            <FormControl id="email">
              <FormLabel>Email address</FormLabel>
              <Input
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormControl>
            <Button type="submit" colorScheme="pink" size="lg" fontSize="md">
              Submit
            </Button>
          </Stack>
        </chakra.form>
        {/* <DividerWithText my={6}>OR</DividerWithText> */}
        <Center>
          <Button variant="link" onClick={() => history.push("/login")}>
            Login
          </Button>
        </Center>
      </Card>
    </Layout>
  );
}
